import React from 'react';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faSignIn } from '@fortawesome/free-solid-svg-icons';
import styled, { css } from 'styled-components';

import Logo from 'assets/tastyfxlogo.inline.svg';

import IconButton from 'components/IconButton/IconButton';
import Link from 'components/Link';

import { MobileNavI } from 'interfaces/content-stack/header';

import { headerMenuSpecialBehavior } from 'utils/constants';
import { getModularBlockLink, getModularBlockLinkData } from 'utils/modularBlockUtils';

const MobileNavWrapper = styled.div`
  ${({ theme }) => css`
    position: sticky;
    top: 0;
    width: 100%;
    background-color: ${theme.colors.white};
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    gap: 2.5rem;
    height: 3.75rem;
    box-shadow: ${theme.colors.boxShadowGray} 0 0.0625rem 0.125rem 0;
    z-index: 1000;

    @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
      display: flex;
    }
  `}
`;

const NavItemContainerRight = styled.div`
  display: flex;
  align-items: center;
`;

const NavButton = styled(Link)`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    text-decoration: none;
    padding: 0.15rem 0.5rem;
    border-radius: 5rem;
    font-family: ${theme.fonts.default};
    cursor: pointer;
    background-color: ${theme.colors.primaryRed};
    font-size: 0.8125rem;
    text-transform: uppercase;
    font-weight: 600;

    &:hover {
      background-color: ${theme.colors.apple};
    }
  `}
`;

interface MobileNavProps {
  data: MobileNavI;
}

const CampaignMobileNav: React.FC<MobileNavProps> = ({ data }) => {
  const menuIcons: { [item: string]: IconDefinition } = {
    question: faQuestionCircle,
    signin: faSignIn,
  };
  const { navbarItems, menuItems } = data;

  return (
    <MobileNavWrapper data-testid='CampaignMobileNavbar'>
      <Link to='/'>
        <Logo />
      </Link>
      <NavItemContainerRight>
        {menuItems?.map((item, index) => {
          if (item.specialBehavior === headerMenuSpecialBehavior.openAnAccount) {
            return (
              <NavButton to={getModularBlockLink(item.link) ?? ''} key={index}>
                {item.linkText}
              </NavButton>
            );
          }
        })}

        {navbarItems?.map((item, index) => {
          if (item.specialBehavior === headerMenuSpecialBehavior.help) {
            return null;
          }
          const Icon = menuIcons[item.linkIcon];
          const { link, target } = getModularBlockLinkData(item.link);
          return <IconButton key={index} to={link} target={target} icon={Icon} />;
        })}
      </NavItemContainerRight>
    </MobileNavWrapper>
  );
};

export default CampaignMobileNav;
